import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const OPTIONS_VALUES = [
  "aad_001",
  "aad_002",
  "aad_003",
  "aad_004",
  "aad_005",
  "aad_006",
  "aad_007",
  "aad_008",
];

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <CheckboxSurvey
      label={t("actionsDeclaredHarassment.label")}
      {...form.getInputProps("AAD_001_008")}
    >
      {(
        t("actionsDeclaredHarassment.questions", {
          returnObjects: true,
        }) as string[]
      ).map((option, index) => (
        <Checkbox
          key={OPTIONS_VALUES[index]}
          label={option}
          value={OPTIONS_VALUES[index]}
        />
      ))}
    </CheckboxSurvey>
  );
};

export default Component;
